import React from 'react'
import FAQCollapse from './FAQCollapse'

const HomeLoanCopy = () => (
  <div>
    With our residential home loans, you can achieve your goals:
    <ul>
      <li>
        Purchase a new home
      </li>
      <li>
        Refinance to save money
      </li>
      <li>
        Take cash out for personal or investment use (e.g. renovate, have a holiday)
      </li>
      <li>
        Consolidate debts to a cheaper rate into your home loan
      </li>
      <li>
        Release equity
      </li>
    </ul>
  </div>
);

const CommercialCopy = () => (
  <div>
    With our commercial property loans, you can achieve your goals:
    <ul>
      <li>
        Purchase a commercial property as an investment
      </li>
      <li>
        Purchase a commercial property as an owner-occupied premises
      </li>
      <li>
        Renovate or fit a commercial property
      </li>
      <li>
        Consolidate business or commercial debt
      </li>
      <li>
        Refinance an existing commercial property loan to obtain a better interest rate
      </li>
    </ul>
  </div>
);

const FAQ = () => (
  <div className="section mb-3" id="faq">
    <div className="container">
      <h3 className="text-center mb-5">Your important questions answered</h3>
      <div className='content'>
        <FAQCollapse
          id="objective"
          title="What objective are Yard's residential home loans available for?"
          content={<HomeLoanCopy />}
        />
        <FAQCollapse
          id="objective2"
          title="What objective are Yard's commercial property loans available for?"
          content={<CommercialCopy />}
        />
        <FAQCollapse
          id="borrow-amount"
          title="Can I make additional repayments?"
          content="You can make unlimited additional repayments free of charge towards your variable residential loan and up to $20,000 per year free of charge towards your fixed term loan."
        />
        <FAQCollapse
          id="loan-amount"
          title="Can I have an offset account?"
          content="Yard provides an optional 100% offset facility. You may select this feature to pay off the principal of your loan faster and reduce your interest repayments. Our multi-offset product lets you link up to 10 offset accounts against your loan account. The offset account comes with electronic payments and an optional Visa Debit Card."
        />
        <FAQCollapse
          id="repayment-period"
          title="Do your loans come with a redraw facility?"
          content="Unlimited free online redraw is available for our residential variable rate loans if you are ahead on your repayments. Redraw is not available for SMSF loans but you still have the option to add a 100% offset facility to reduce your interest repayments."
        />
        <FAQCollapse
          id="additional-repayments"
          title="Do you offer split loans?"
          content="Yard can provide split loans. You can split your loan between different interest rate types (variable and fixed) and repayment types (principal & interest and interest only)."
        />
        <FAQCollapse
          id="redraw"
          title="Does Yard offer fixed rates?"
          content="Yes, we offer fixed rates between 1 to 5 years."
        />
        <FAQCollapse
          id="offset-account"
          title="Do you lend to trust and company borrowers?"
          content="We can accept trust and company borrowers. Different terms & conditions, interest rates and fees may apply."
        />
        <FAQCollapse
          id="interest-only"
          title="Does Yard offer loans for vacant land and construction?"
          content="Yes, we lend for vacant land, and residential construction projects. Different terms & conditions, interest rates and fees apply."
        />
      </div>

      <div className="text-center mt-5">
        <a className="green bigger see-all-text mt-3" href="/pages/faq"><b>See all FAQs</b></a>
      </div>
    </div>
  </div>
);

export default FAQ;
